import React, { useEffect, useRef, useState } from "react";

import Image from "next/image";

import Google from "assets/home/calculator-example/web-google.png";
import Dictionary from "assets/home/calculator-example/dictionary-extension-16.png";
import FileSearch from "assets/home/calculator-example/command-file-search-16.png";

import ArrowRight from "assets/iconsv2/arrow-right-16.svg";

import styles from "./CalculatorExample.module.css";

function detectBrowser() {
  if ((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf("OPR")) != -1) {
    return "Opera";
  } else if (navigator.userAgent.indexOf("Chrome") != -1) {
    return "Chrome";
  } else if (navigator.userAgent.indexOf("Firefox") != -1) {
    return "Firefox";
  } else {
    // Use Safari as default browser name
    return "Safari";
  }
}

const incrementHours = 2;
const searchTimeZone = "Asia/Dubai";
const query = `time in dubai + ${incrementHours} hours`;

const useTimeCalculationExample = () => {
  const currentTimeTimer = useRef<NodeJS.Timer>();
  const [currentTime, setCurrentTime] = useState<Date>();

  useEffect(() => {
    currentTimeTimer.current = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(currentTimeTimer.current);
    };
  }, []);

  if (!(currentTime instanceof Date)) {
    return ["", ""];
  }

  const timeString = currentTime.toLocaleString("en-US", {
    timeStyle: "short",
    timeZone: searchTimeZone,
  });
  const newTime = new Date(currentTime.getTime() + incrementHours * 60 * 60000);
  const newTimeString = newTime.toLocaleString("en-US", {
    hour12: false,
    timeStyle: "short",
    timeZone: searchTimeZone,
  });
  const info = `${timeString}, GMT+4`;
  const newLocaleString = `${newTimeString}`;

  return [info, newLocaleString];
};

const CalculatorExample: React.FC = () => {
  const [browserName, setBrowserName] = useState("");
  const [info, newLocaleString] = useTimeCalculationExample();

  useEffect(() => {
    setBrowserName(detectBrowser());
  }, []);

  return (
    <div className={styles.frame}>
      <div className={styles.search}>{query}</div>
      <div className={styles.heading}>Calculator</div>

      <div className={styles.calculator}>
        <div className={styles.query}>
          <div>{query}</div>
          <div className={styles.hint}>{info}</div>
        </div>
        <div className={styles.separator}>
          <ArrowRight className="icon" />
        </div>
        <div className={styles.answer}>
          <div>{newLocaleString}</div>
          <div className={styles.hint}>Answer</div>
        </div>
      </div>

      <div className={styles.heading}>Use &quot;{query}&quot; with...</div>
      <div className={styles.fallbackSearches}>
        <div>
          <Image src={Google} width={20} height={20} layout="fixed" alt="Google Icon" />
          <span className={styles.title}>Google</span>
          <span className={styles.subtitle}>{browserName}</span>
        </div>
        <div>
          <Image src={Dictionary} width={20} height={20} layout="fixed" alt="Dictionary Icon" />
          <span className={styles.title}>Dictionary</span>
          <span className={styles.subtitle}>Dictionary</span>
        </div>
        <div>
          <Image src={FileSearch} width={20} height={20} layout="fixed" alt="File Search Icon" />
          <span className={styles.title}>File Search</span>
          <span className={styles.subtitle}>File Search</span>
        </div>
      </div>
    </div>
  );
};

export default CalculatorExample;
